const adminHelpFeature = {
  id: "admin-help-section",
  name: "feature.admin-help-section.name",
  iconClass: "fal fa-question-circle",
  globalSettings: {},
  schema: {}
};

export { adminHelpFeature };